import HomeController from "./home";
import NavController from "./nav";
import SliderController from "./sliders";
import { UIController } from "./ui";
import { Home } from "./home.controller";
export var app = {
    init: function () {
        UIController.init();
        NavController.init();
        HomeController.init();
        SliderController.init();
        Home.init();
    },
};
document.addEventListener("DOMContentLoaded", function (event) {
    app.init();
});
